import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { translate } from 'utils/translate';

interface reFetchMetoceanModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;

    //unused props
    data: any;

    actions: ActionsType | undefined;
}

interface reFetchMetoceanModelState {
    //unused state
    errors: object;

    //unused state
    data: any | null;

    loading: boolean;
}

class reFetchMetoceanModel extends Component<reFetchMetoceanModelProps, reFetchMetoceanModelState> {
    constructor(props: reFetchMetoceanModelProps) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            loading: false,
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onConfirm();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form
                    onSubmit={this.handleFormSubmit}
                    className="bg-white shadow p-4 w-full rounded"
                    style={{ width: '550px' }}
                >
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Update MetOcean data')}</div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <div className="flex items-center gap-1 text-md text-gray-600">
                        {translate('Are you sure you get the latest Metocean data.?')}
                    </div>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                type="submit"
                                className="px-4 py-2 bg-yellow-100 text-yellow-700 rounded-md  "
                            >
                                {translate('Update')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const reFetchMetoceanModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reFetchMetoceanModelDispatchToProps = () => ({});

export default connect(reFetchMetoceanModelStateToProps, reFetchMetoceanModelDispatchToProps)(reFetchMetoceanModel);
